import { CollectionFilter } from 'interfaces/collection-filter';

export const PetType = {
  Cat: 'cat',
  Dog: 'dog',
} as const;

export type PetType = (typeof PetType)[keyof typeof PetType];

export const CdpType = {
  BreedCdp: '0',
  NeedCdp: '1',
  AgeTypeCdp: '2',
  FoodTypeCdp: '3',
  Home: '4',
  YourPetProfile: '5',
} as const;

export type CdpType = (typeof CdpType)[keyof typeof CdpType];

/**
 * Mapper for CDP type and filter combination and it's order.
 * @see https://docs.google.com/spreadsheets/d/1cE3zs5OLUE1jgvy1AXcALUTJjzJblWJ72IW3MGuiC6s/edit?pli=1&gid=1714492367#gid=1714492367
 */
export const FilterOrderMapper: Record<
  CdpType,
  Record<PetType, Array<CollectionFilter> | Array<Array<CollectionFilter>>>
> = {
  [CdpType.BreedCdp]: {
    [PetType.Cat]: ['feed-type', 'sorts', 'desires'],
    [PetType.Dog]: ['feed-type', 'sorts', 'desires'],
  },
  [CdpType.NeedCdp]: {
    [PetType.Cat]: ['feed-type', 'sorts', 'desires'],
    [PetType.Dog]: ['feed-type', 'sorts', 'desires'],
  },
  [CdpType.AgeTypeCdp]: {
    [PetType.Cat]: ['feed-type', 'sorts', 'desires'],
    [PetType.Dog]: ['feed-type', 'sorts', 'desires'],
  },
  [CdpType.FoodTypeCdp]: {
    [PetType.Cat]: [
      ['nutritional-needs', 'age', 'sorts', 'desires', 'sizes'],
      ['sorts', 'desires', 'sizes'],
    ],
    [PetType.Dog]: [
      ['nutritional-needs', 'age', 'sorts', 'desires', 'sizes'],
      ['sorts', 'desires', 'sizes'],
    ],
  },
  [CdpType.Home]: {
    [PetType.Cat]: ['nutritional-needs', 'age', 'feed-type', 'sorts'],
    [PetType.Dog]: ['nutritional-needs', 'age', 'feed-type', 'sorts'],
  },
  [CdpType.YourPetProfile]: {
    [PetType.Cat]: ['desires'],
    [PetType.Dog]: ['sorts', 'desires'],
  },
} as const;

export type FilterOrderMapper = (typeof FilterOrderMapper)[keyof typeof FilterOrderMapper][PetType];
